var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoGhostingFromFreelancers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113.22 158.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-8);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-1,.cls-2,.cls-5{stroke-width:2px;}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:#fff;}.cls-8{fill:url(#linear-gradient-6);}.cls-2,.cls-9{fill:#267bfa;}.cls-10,.cls-11{opacity:.15;}.cls-11{fill:#020004;}.cls-3{fill:rgba(255,255,255,.8);stroke-width:4px;}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-7);}.cls-14{fill:url(#linear-gradient-3);}.cls-15{fill:url(#linear-gradient);}.cls-4{fill:rgba(255,255,255,.47);}.cls-5{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 93.3,
    y1: 61.56,
    x2: 104.81,
    y2: 61.56,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d95f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2180f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 79.6,
    y1: 48.92,
    x2: 104.81,
    y2: 48.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 70.53,
    y1: 36.04,
    x2: 104.81,
    y2: 36.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 81.44,
    y1: 22.47,
    x2: 104.81,
    y2: 22.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 60.15,
    y1: 74.19,
    x2: 104.81,
    y2: 74.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 60.15,
    y1: 95.34,
    x2: 104.81,
    y2: 95.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 60.15,
    y1: 117,
    x2: 104.81,
    y2: 117,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 24.83,
    y1: 92.27,
    x2: 24.83,
    y2: 79.24,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 52.89,
    x2: 52.89,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "overlay",
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M109.32,11.17V147.06c0,3.78-3.12,6.85-6.97,6.85H46.26c-3.85,0-6.97-3.07-6.97-6.85V11.17c0-3.78,3.12-6.85,6.97-6.85h6.98c.79,0,1.43,.63,1.43,1.41,0,1.08,.44,2.05,1.16,2.75,.72,.7,1.71,1.14,2.8,1.14h31.34c2.19,0,3.96-1.74,3.96-3.89,0-.39,.16-.74,.42-.99,.26-.26,.62-.41,1.01-.41h6.98c3.85,0,6.97,3.07,6.97,6.85Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46.57,157.24c-5.61,0-10.18-4.55-10.18-10.14V11.14c0-5.59,4.57-10.14,10.18-10.14h55.47c5.62,0,10.19,4.55,10.19,10.14V147.1c0,5.59-4.57,10.14-10.19,10.14H46.57Zm-.26-153.41c-4.12,0-7.47,3.3-7.47,7.35V147.06c0,4.05,3.35,7.35,7.47,7.35h56.1c4.12,0,7.47-3.3,7.47-7.35V11.18c0-4.05-3.35-7.35-7.47-7.35h-6.98c-.52,0-1,.2-1.36,.56-.37,.36-.57,.84-.57,1.35,0,1.87-1.55,3.39-3.46,3.39h-31.34c-.93,0-1.8-.35-2.45-1-.65-.64-1.01-1.49-1.01-2.4,0-1.05-.87-1.91-1.93-1.91h-6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M102.04,1.5c5.34,0,9.69,4.32,9.69,9.64V147.1c0,5.31-4.34,9.64-9.69,9.64H46.57c-5.34,0-9.68-4.32-9.68-9.64V11.14c0-5.32,4.34-9.64,9.68-9.64h55.47m-43.34,7.13c-.79,0-1.54-.3-2.1-.85-.56-.55-.86-1.27-.86-2.04,0-1.33-1.09-2.41-2.43-2.41h-6.98c-4.39,0-7.97,3.52-7.97,7.85V147.06c0,4.33,3.58,7.85,7.97,7.85h56.1c4.39,0,7.97-3.52,7.97-7.85V11.17c0-4.33-3.58-7.85-7.97-7.85h-6.98c-.65,0-1.26,.25-1.71,.7-.46,.45-.72,1.06-.72,1.71,0,1.6-1.33,2.89-2.96,2.89h-31.34M102.04,.5H46.57c-5.9,0-10.68,4.76-10.68,10.64V147.1c0,5.88,4.78,10.64,10.68,10.64h55.47c5.9,0,10.69-4.76,10.69-10.64V11.14c0-5.88-4.78-10.64-10.69-10.64h0ZM58.69,9.63h31.34c2.19,0,3.96-1.74,3.96-3.89,0-.39,.16-.74,.42-.99,.26-.26,.62-.41,1.01-.41h6.98c3.85,0,6.97,3.07,6.97,6.85V147.06c0,3.78-3.12,6.85-6.97,6.85H46.32c-3.85,0-6.97-3.07-6.97-6.85V11.17c0-3.78,3.12-6.85,6.97-6.85h6.98c.79,0,1.43,.63,1.43,1.41,0,1.08,.44,2.05,1.16,2.75,.72,.7,1.71,1.14,2.8,1.14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M78.05,5.39h-7.54c-.19,0-.34-.15-.34-.34s.15-.34,.34-.34h7.54c.19,0,.34,.15,.34,.34s-.15,.34-.34,.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.05,4.71h-7.54c-.19,0-.34,.15-.34,.34s.15,.34,.34,.34h7.54c.19,0,.34-.15,.34-.34s-.15-.34-.34-.34h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 83.34,
    cy: 5.05,
    r: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.34,4.15c-.5,0-.9,.4-.9,.9s.4,.9,.9,.9,.9-.4,.9-.9-.4-.9-.9-.9h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.32,11.17V147.06c0,3.78-3.12,6.85-6.97,6.85H46.26c-3.85,0-6.97-3.07-6.97-6.85V11.17c0-3.78,3.12-6.85,6.97-6.85h6.98c.79,0,1.43,.63,1.43,1.41,0,1.08,.44,2.05,1.16,2.75,.72,.7,1.71,1.14,2.8,1.14h31.34c2.19,0,3.96-1.74,3.96-3.89,0-.39,.16-.74,.42-.99,.26-.26,.62-.41,1.01-.41h6.98c3.85,0,6.97,3.07,6.97,6.85Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.32,
    y1: 20.05,
    x2: 35.32,
    y2: 25.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.32,
    y1: 32.58,
    x2: 35.32,
    y2: 44.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 35.32,
    y1: 46.99,
    x2: 35.32,
    y2: 58.87
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 93.3,
    y: 58.1,
    width: 11.51,
    height: 6.91,
    rx: 3.46,
    ry: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 79.6,
    y: 45.47,
    width: 25.21,
    height: 6.91,
    rx: 3.46,
    ry: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 70.53,
    y: 32.58,
    width: 34.29,
    height: 6.91,
    rx: 3.46,
    ry: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 81.44,
    y: 19.01,
    width: 23.38,
    height: 6.91,
    rx: 3.46,
    ry: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 60.15,
    y: 70.73,
    width: 44.67,
    height: 6.91,
    rx: 3.46,
    ry: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 60.15,
    y: 83.06,
    width: 44.67,
    height: 24.57,
    rx: 3.46,
    ry: 3.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 60.15,
    y: 111.28,
    width: 44.67,
    height: 11.43,
    rx: 3.46,
    ry: 3.46
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 43.23,
    y: 135.35,
    width: 61.58,
    height: 10.59,
    rx: 2.71,
    ry: 2.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M86.57,85.42c-.22-20.4-18.12-36.88-40.19-36.88S6.41,65.02,6.19,85.42h-.02v41.33h0v14.77c0,1.97,2.39,2.96,3.78,1.57l4.71-4.71c.87-.87,2.27-.87,3.13,0l6.92,6.92c.87,.87,2.27,.87,3.13,0l6.92-6.92c.87-.87,2.27-.87,3.13,0l6.92,6.92c.87,.87,2.27,.87,3.13,0l6.92-6.92c.87-.87,2.27-.87,3.13,0l6.92,6.92c.87,.87,2.27,.87,3.13,0l6.92-6.92c.87-.87,2.27-.87,3.14,0l4.69,4.7c1.4,1.4,3.79,.41,3.79-1.57v-56.09h-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.7,85.41c-.21-18.7-16.61-33.81-36.84-33.81S2.23,66.7,2.02,85.41h-.02v37.89h0v13.54c0,1.81,2.19,2.72,3.47,1.44l4.32-4.32c.79-.79,2.08-.79,2.87,0l6.34,6.34c.79,.79,2.08,.79,2.87,0l6.34-6.34c.79-.79,2.08-.79,2.87,0l6.34,6.34c.79,.79,2.08,.79,2.87,0l6.34-6.34c.79-.79,2.08-.79,2.87,0l6.34,6.34c.79,.79,2.08,.79,2.87,0l6.34-6.34c.79-.79,2.08-.79,2.87,0l4.3,4.31c1.28,1.28,3.47,.38,3.47-1.44v-51.42h-.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.83,
    cy: 85.76,
    r: 6.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 52.89,
    cy: 85.76,
    r: 6.52
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGhostingFromFreelancers);
export default __webpack_public_path__ + "static/media/no-ghosting-from-freelancers.d5065d0c3e71e926ea525403a271212e.svg";
export { ForwardRef as ReactComponent };